export default __webpack_public_path__ + "static/media/howtouse_plus_06_ko.d9cfc57a.png";